(function () {
  'use strict';

  var INITIALIZED = 'data-bb-mattress-advisor-ready';

  function numberValue(input) {
    var value = Number(input && input.value);
    return Number.isFinite(value) ? value : null;
  }

  function bmi(heightCm, weightKg) {
    var metres = heightCm / 100;
    return weightKg / (metres * metres);
  }

  function withinAupingChart(height, weight) {
    return height >= 150 && height <= 220 && weight >= 40 && weight <= 140;
  }

  function aupingBodyAdvice(height, weight) {
    if (!withinAupingChart(height, weight)) return { outside: true };
    var value = bmi(height, weight);
    if (value < 24) return { label: 'Soft', active: ['Soft'] };
    if (value < 28) return { label: 'Medium', active: ['Medium'] };
    return { label: 'Firm', active: ['Firm'] };
  }

  function aupingOneTwoAdvice(height, weight) {
    if (!withinAupingChart(height, weight)) return { outside: true };
    return bmi(height, weight) < 27
      ? { label: 'Medium', active: ['Medium'] }
      : { label: 'Firm', active: ['Firm'] };
  }

  function aupingUpholsteredAdvice(height, weight) {
    if (!withinAupingChart(height, weight)) return { outside: true };
    var value = bmi(height, weight);
    if (value < 22) return { label: 'Soft', active: ['Soft'] };
    if (value < 27) return { label: 'Medium', active: ['Medium'] };
    if (value < 31) return { label: 'Firm', active: ['Firm'] };
    return { label: 'Extra Firm', active: ['Extra Firm'] };
  }

  var PULLMAN_MATRIX = [
    ['Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm', 'Firm', 'Firm', 'Firm', 'Firm', 'Firm'],
    ['Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm', 'Firm', 'Firm', 'Firm', 'Firm'],
    ['Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm', 'Firm', 'Firm', 'Firm'],
    ['Standard', 'Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm', 'Firm', 'Firm'],
    ['Standard', 'Standard', 'Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm', 'Firm'],
    ['Standard', 'Standard', 'Standard', 'Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Firm'],
    ['Standard', 'Standard', 'Standard', 'Standard', 'Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm'],
    ['Standard', 'Standard', 'Standard', 'Standard', 'Standard', 'Standard', 'Standard / Firm', 'Standard / Firm', 'Standard / Firm']
  ];

  function pullmanRow(height) {
    if (height <= 0 || height > 220) return -1;
    if (height <= 150) return 0;
    if (height <= 160) return 1;
    if (height <= 170) return 2;
    if (height <= 180) return 3;
    if (height <= 190) return 4;
    if (height <= 200) return 5;
    if (height <= 210) return 6;
    return 7;
  }

  function pullmanColumn(weight) {
    if (weight <= 0) return -1;
    if (weight <= 50) return 0;
    if (weight <= 60) return 1;
    if (weight <= 70) return 2;
    if (weight <= 80) return 3;
    if (weight <= 90) return 4;
    if (weight <= 100) return 5;
    if (weight <= 110) return 6;
    if (weight <= 120) return 7;
    return 8;
  }

  function pullmanAdvice(height, weight) {
    var row = pullmanRow(height);
    var col = pullmanColumn(weight);
    if (row < 0 || col < 0) return { outside: true };
    var label = PULLMAN_MATRIX[row][col];
    return {
      label: label,
      active: label === 'Standard / Firm' ? ['Standard', 'Firm'] : [label]
    };
  }

  function labelsFor(profile, premier) {
    if (profile === 'auping_body') return ['Soft', 'Medium', 'Firm'];
    if (profile === 'auping_one_two') return ['Medium', 'Firm'];
    if (profile === 'auping_upholstered') return ['Soft', 'Medium', 'Firm', 'Extra Firm'];
    if (profile === 'pullman') return premier ? ['Standard', 'Firm', 'Extra Firm'] : ['Standard', 'Firm'];
    return [];
  }

  function createChip(text, accent) {
    var chip = document.createElement('span');
    chip.className = 'bb-mattress-advisor__chip' + (accent ? ' bb-mattress-advisor__chip--accent' : '');
    chip.textContent = text;
    return chip;
  }

  function renderMeter(root, profile, premier, activeLabels) {
    var meter = root.querySelector('[data-advisor-meter]');
    var wrap = root.querySelector('[data-advisor-meter-wrap]');
    if (!meter || !wrap) return;
    meter.replaceChildren();
    var labels = labelsFor(profile, premier);
    meter.style.setProperty('--bb-advisor-segments', labels.length || 1);
    labels.forEach(function (label) {
      var segment = document.createElement('span');
      segment.className = 'bb-mattress-advisor__meter-segment';
      segment.textContent = label;
      if (activeLabels.indexOf(label) !== -1) segment.classList.add('is-active');
      if (profile === 'pullman' && premier && label === 'Extra Firm' && activeLabels.indexOf(label) === -1) {
        segment.classList.add('is-secondary');
        segment.setAttribute('title', 'Wel leverbaar op Silverline Premier; geen aparte uitkomst van de duurzaamheidstabel');
      }
      meter.appendChild(segment);
    });
    wrap.hidden = !labels.length;
  }

  function selectedBodytype(form) {
    var selected = form.querySelector('input[type="radio"]:checked');
    return selected ? selected.value : '';
  }

  function calculate(profile, height, weight) {
    if (profile === 'auping_body') return aupingBodyAdvice(height, weight);
    if (profile === 'auping_one_two') return aupingOneTwoAdvice(height, weight);
    if (profile === 'auping_upholstered') return aupingUpholsteredAdvice(height, weight);
    if (profile === 'pullman') return pullmanAdvice(height, weight);
    return { outside: true };
  }

  function profileName(profile) {
    if (profile === 'pullman') return 'Pullman';
    return 'Auping';
  }

  function stripMattressWord(title) {
    return String(title || '').replace(/\s+matras$/i, '').trim();
  }

  function init(root) {
    if (!root || root.hasAttribute(INITIALIZED)) return;
    root.setAttribute(INITIALIZED, '');

    var profile = root.getAttribute('data-profile') || '';
    var productTitle = root.getAttribute('data-product-title') || 'Dit matras';
    var premier = root.getAttribute('data-premier') === 'true';
    var form = root.querySelector('[data-advisor-form]');
    var heightInput = root.querySelector('[data-advisor-height]');
    var weightInput = root.querySelector('[data-advisor-weight]');
    var empty = root.querySelector('[data-advisor-empty]');
    var content = root.querySelector('[data-advisor-content]');
    var kicker = root.querySelector('[data-advisor-kicker]');
    var title = root.querySelector('[data-advisor-title]');
    var summary = root.querySelector('[data-advisor-summary]');
    var explanation = root.querySelector('[data-advisor-explanation]');
    var reset = root.querySelector('[data-advisor-reset]');

    if (!form || !heightInput || !weightInput || !empty || !content) return;

    function showResult(advice, height, weight, bodytype) {
      empty.hidden = true;
      content.hidden = false;
      summary.replaceChildren();

      if (advice.outside) {
        kicker.textContent = 'Buiten bereik fabrikantentabel';
        title.textContent = 'Laat deze combinatie persoonlijk beoordelen';
        summary.appendChild(createChip(height + ' cm', false));
        summary.appendChild(createChip(weight + ' kg', false));
        explanation.textContent = profile === 'pullman'
          ? 'Deze lengte valt buiten het bereik van de Pullman-tabel die we hier gebruiken. In de showroom bepalen we de passende uitvoering.'
          : 'Deze combinatie valt buiten het weergegeven bereik van de Auping-grafiek (150–220 cm en 40–140 kg). We extrapoleren het fabrikantadvies daarom niet.';
        var meterWrap = root.querySelector('[data-advisor-meter-wrap]');
        if (meterWrap) meterWrap.hidden = true;
        return;
      }

      var model = stripMattressWord(productTitle);
      kicker.textContent = profile === 'pullman' ? 'Duurzaamheidsadvies volgens Pullman' : 'Advies volgens Auping';
      title.textContent = profile === 'auping_body'
        ? model + ' ' + bodytype + ' — ' + advice.label
        : model + ' — ' + advice.label;

      summary.appendChild(createChip(height + ' cm', false));
      summary.appendChild(createChip(weight + ' kg', false));
      if (bodytype) summary.appendChild(createChip('Type ' + bodytype, false));
      summary.appendChild(createChip(advice.label, true));

      renderMeter(root, profile, premier, advice.active || []);

      if (profile === 'auping_body') {
        explanation.textContent = 'Je lengte en gewicht geven ' + advice.label + ' als hardheidsadvies. Voor de zonering heb je Type ' + bodytype + ' gekozen op basis van je lichaamsverhouding.';
      } else if (profile === 'auping_one_two') {
        explanation.textContent = 'Op basis van je lengte en gewicht valt deze combinatie in de Auping BMI-tabel onder ' + advice.label + '.';
      } else if (profile === 'auping_upholstered') {
        explanation.textContent = 'Op basis van je lengte en gewicht valt deze combinatie in de indicatieve Auping-grafiek onder ' + advice.label + '.';
      } else {
        explanation.textContent = advice.label === 'Standard / Firm'
          ? 'Volgens de Pullman-duurzaamheidstabel zijn Standard en Firm voor deze lengte/gewicht-combinatie beide mogelijk; de uiteindelijke keuze is individueel.'
          : 'Volgens de Pullman-duurzaamheidstabel hoort bij deze lengte/gewicht-combinatie ' + advice.label + '.';
      }

      try {
        root.dispatchEvent(new CustomEvent('bb:mattress-advice', {
          bubbles: true,
          detail: {
            profile: profile,
            productTitle: productTitle,
            height: height,
            weight: weight,
            bodytype: bodytype || null,
            recommendation: advice.label
          }
        }));
      } catch (e) {}
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;

      var height = numberValue(heightInput);
      var weight = numberValue(weightInput);
      if (height == null || weight == null) return;

      var bodytype = profile === 'auping_body' ? selectedBodytype(form) : '';
      if (profile === 'auping_body' && !bodytype) {
        var firstRadio = form.querySelector('input[type="radio"]');
        if (firstRadio) firstRadio.focus();
        return;
      }

      showResult(calculate(profile, height, weight), height, weight, bodytype);

      if (window.matchMedia && window.matchMedia('(max-width: 699px)').matches) {
        content.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    if (reset) {
      reset.addEventListener('click', function () {
        form.reset();
        content.hidden = true;
        empty.hidden = false;
        heightInput.focus();
      });
    }
  }

  function initAll(scope) {
    var base = scope || document;
    if (base.matches && base.matches('[data-bb-mattress-advisor]')) init(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('[data-bb-mattress-advisor]').forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
